import clsx from "clsx";
import { ArrowClockwise, House } from "@phosphor-icons/react";
import { useNavigate } from "react-router";
import type { QuizSummaryDto } from "./quizApi";

export default function QuizSummary({
  summary,
  onRestart,
}: {
  summary: QuizSummaryDto;
  onRestart: () => void;
}) {
  const navigate = useNavigate();
  const pct = summary.score;

  return (
    <div className="flex flex-col gap-6 max-w-3xl mx-auto py-10">
      <div className="text-center">
        <div className="flex items-center justify-center gap-2 text-sm text-white/50">
          Modül Sonu Pratik
        </div>
        <div
          className={clsx(
            "text-5xl font-bold mt-2",
            pct >= 70 ? "text-myGreen" : pct >= 40 ? "text-white" : "text-myRed",
          )}
        >
          %{pct}
        </div>
        <div className="text-white/60 mt-1">
          İlk denemede {summary.firstTryCorrect ?? summary.correct}/{summary.total} doğru
          {summary.solved != null && summary.solved > (summary.firstTryCorrect ?? summary.correct) && (
            <> · tekrar deneyerek toplam {summary.solved}/{summary.total} çözüldü</>
          )}
        </div>
        {summary.solved != null && summary.solved > (summary.firstTryCorrect ?? summary.correct) && (
          <p className="text-xs text-white/40 mt-2 max-w-md mx-auto">
            İlk denemede doğru olan soru tam puan, tekrar deneyerek çözdüğün soru yarım puan alır.
          </p>
        )}
      </div>

      {summary.weakTopics.length > 0 && (
        <div className="bg-myGb/30 rounded-2xl p-5">
          <div className="font-semibold text-white/90 mb-1">Tekrar etmen iyi olur</div>
          <p className="text-xs text-white/50 mb-3">
            Bu konulardan sonraki modüllerin pratiğinde daha sık soru gelecek.
          </p>
          <ul className="flex flex-col gap-2">
            {summary.weakTopics.map((t) => (
              <li key={t.code} className="flex items-center justify-between text-sm">
                <span className="text-white/80">{t.title}</span>
                <span className="text-white/50 text-xs">
                  {t.correct}/{t.asked}
                </span>
              </li>
            ))}
          </ul>
        </div>
      )}

      <div className="bg-myGb/20 rounded-2xl p-5">
        <div className="font-semibold text-white/90 mb-3">Konu bazlı sonuç</div>
        <ul className="flex flex-col gap-2">
          {summary.topics.map((t) => {
            const ratio = t.asked > 0 ? t.correct / t.asked : 0;
            return (
              <li key={t.code} className="flex items-center gap-3 text-sm">
                <span className="flex-1 text-white/70">{t.title}</span>
                <div className="w-28 h-1.5 rounded-full bg-white/10 overflow-hidden">
                  <div
                    className={clsx(
                      "h-full rounded-full",
                      ratio >= 0.7 ? "bg-myGreen" : ratio >= 0.4 ? "bg-white/60" : "bg-myRed",
                    )}
                    style={{ width: `${Math.round(ratio * 100)}%` }}
                  />
                </div>
                <span className="text-white/40 text-xs w-10 text-right">
                  {t.correct}/{t.asked}
                </span>
              </li>
            );
          })}
        </ul>
      </div>

      <div className="flex gap-3 justify-center">
        <button
          type="button"
          onClick={onRestart}
          className="practice-button bg-myGreen/80 border border-myGreen text-black/80 hover:bg-myGreen flex items-center gap-2"
        >
          <ArrowClockwise weight="bold" /> Yeni set çöz
        </button>
        <button
          type="button"
          onClick={() => navigate("/")}
          className="practice-button bg-myGb/50 flex items-center gap-2"
        >
          <House weight="bold" /> Ana sayfa
        </button>
      </div>
    </div>
  );
}
